import React from "react";
export function CorrectAnswer(props) {
  return (
    <span class={props.class}>
      <img src="/correct.png" width="17px" alt="" />
    </span>
  );
}
